export const HourMinuteMask = 'Hh:m0';
export const WeekMask = '00:00';
export const CNPJMask = '00.000.000/0000-00';
export const CPFCNPJMask = '000.000.000-009';
export const CPFMask = '000.000.000-00';
export const CelMask = '(00) 00000-0000';
export const TelMask = '(00) 0000-00009';
export const CepMask = '00.000-000';